module.exports = __webpack_public_path__ + "media/images/about_us_jenn-1375db55b18935e766305cd7b3b618b89c5b3db278e4737e17bed77fb40938c9.jpg";